const danhSachLoaiLichLamViec = state => state.danhSachLoaiLichLamViec;

const danhSachLichLamViec = state => state.danhSachLichLamViec;
const danhSachLoaiLichCon = state => state.danhSachLoaiLichCon;
const chiTietLichLamViec = state => state.chiTietLichLamViec;
export default {
  danhSachLoaiLichLamViec,
  danhSachLichLamViec,
    danhSachLoaiLichCon,
    chiTietLichLamViec
};
